(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-friday-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('black-friday-announcement')) {
    customElements.define('black-friday-announcement', class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;
        this.updateHeight = () => {
          this.frame = null;
          document.documentElement.style.setProperty('--bf-announcement-height', `${this.getBoundingClientRect().height}px`);
          const section = this.closest('.black-friday-announcement-section');
          const header = document.querySelector('.header-section');
          const followsHeader = header && (header.compareDocumentPosition(section) & Node.DOCUMENT_POSITION_FOLLOWING);
          const nav = header?.querySelector('.header') || header;
          section?.style.setProperty('--bf-nav-offset', `${followsHeader ? Math.max(0, nav.getBoundingClientRect().bottom) : 0}px`);
        };
        this.scheduleUpdate = () => {
          if (this.frame == null) this.frame = requestAnimationFrame(this.updateHeight);
        };
        this.updateHeight();
        this.observer = new ResizeObserver(this.scheduleUpdate);
        this.observer.observe(this);
        const header = document.querySelector('.header-section .header');
        if (header) this.observer.observe(header);
        window.addEventListener('scroll', this.scheduleUpdate, { passive: true });
        window.addEventListener('resize', this.scheduleUpdate);
        document.addEventListener('shopify:section:reorder', this.scheduleUpdate);
        document.addEventListener('shopify:section:load', this.scheduleUpdate);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        cancelAnimationFrame(this.frame);
        this.frame = null;
        window.removeEventListener('scroll', this.scheduleUpdate);
        window.removeEventListener('resize', this.scheduleUpdate);
        document.removeEventListener('shopify:section:reorder', this.scheduleUpdate);
        document.removeEventListener('shopify:section:load', this.scheduleUpdate);
        document.documentElement.style.removeProperty('--bf-announcement-height');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-ceramic"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bf-ceramic')) {
  customElements.define('bf-ceramic', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      this.video = this.querySelector('video');
      this.buttons = [...this.querySelectorAll('[data-index]')];
      this.classList.add('is-ready');
      this.buttons.forEach(button => {
        button.addEventListener('click', () => this.select(Number(button.dataset.index)), options);
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const index = Number(button.dataset.index);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.buttons.length) % this.buttons.length;
          this.select(next);
          this.buttons[next].focus();
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const button = this.buttons.find(item => item.dataset.blockId === event.detail.blockId);
        if (button) this.select(Number(button.dataset.index));
      }, options);
      if (this.video) {
        this.video.addEventListener('playing', () => this.classList.add('is-playing'), options);
      } else this.classList.add('is-playing');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const reveal = entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= .55) {
          if (this.video && !reduced) {
            this.video.controls = false;
            this.video.play().catch(() => { if (this.isConnected) this.video.controls = true; });
          }
        } else if (!entry.isIntersecting && this.video) {
          this.video.pause();
          this.classList.remove('is-playing');
        }
      };
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => entries.forEach(reveal), {threshold:[0,.55]});
        this.observer.observe(this.querySelector('.bf-ceramic__video'));
        this.priceObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.classList.add('is-offer-visible');
            this.priceObserver.disconnect();
          }
        }, {threshold:.6});
        this.priceObserver.observe(this.querySelector('.bf-ceramic__pricing'));
      } else {
        reveal({isIntersecting:true, intersectionRatio:1});
        this.classList.add('is-offer-visible');
      }
    }
    select(index) {
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.index) === index)));
      this.querySelectorAll('[data-slide]').forEach(slide => { slide.hidden = Number(slide.dataset.slide) !== index; });
      this.querySelectorAll('[data-ring]').forEach(ring => { ring.hidden = ring.dataset.ring !== (index < 3 ? 'black' : 'white'); });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.priceObserver?.disconnect();
      this.events?.abort();
      this.events = null;
      this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-community"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bf-community-count')) {
    customElements.define('bf-community-count', class extends HTMLElement {
      connectedCallback() {
        if (this.observer || this.played) return;
        const finalText = this.dataset.count || this.textContent;
        this.finalText = finalText;
        const match = finalText.match(/^(\s*)(\d[\d,]*)(\s*\+?\s*)$/);
        const target = match ? Number(match[2].replace(/,/g,'')) : NaN;
        if (!Number.isSafeInteger(target) || target <= 0 || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        const format = value => match[1] + (match[2].includes(',') ? value.toLocaleString('en-US') : String(value)) + match[3];
        this.textContent = format(0);
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.played = true;
          let start;
          const tick = now => {
            if (start === undefined) start = now;
            const progress = Math.min((now-start)/2200,1);
            this.textContent = progress === 1 ? finalText : format(Math.floor(target*(1-Math.pow(1-progress,2))));
            if (progress < 1) this.frame = requestAnimationFrame(tick);
          };
          this.frame = requestAnimationFrame(tick);
        }, {threshold:0.65});
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        cancelAnimationFrame(this.frame);
        if (this.finalText) this.textContent = this.finalText;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bf-faq')) {
    customElements.define('bf-faq', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        const items = [...this.querySelectorAll('details')];
        this.items=items;
        items.forEach(item => item.querySelector('summary').addEventListener('click', event => {
          event.preventDefault();
          const opening=!(item.targetOpen ?? item.open);
          if(opening)items.forEach(other=>{if(other!==item&&(other.targetOpen ?? other.open))this.transition(other,false);});
          this.transition(item,opening);
        }, options));
        document.addEventListener('shopify:block:select', event => {
          const selected = items.find(item => item.dataset.blockId === event.detail.blockId);
          if (selected) { items.forEach(other=>{if(other!==selected)this.transition(other,false);});this.transition(selected,true); }
        }, options);
      }
      transition(item,open) {
        const start=item.getBoundingClientRect().height;
        item.animation?.cancel();
        item.targetOpen=open;
        item.open=open;
        const end=item.getBoundingClientRect().height;
        if(matchMedia('(prefers-reduced-motion: reduce)').matches){item.targetOpen=null;return;}
        item.open=true;
        item.style.overflow='hidden';
        const animation=item.animate([{height:start+'px'},{height:end+'px'}],{duration:300,easing:'cubic-bezier(.22,.61,.36,1)'});
        item.animation=animation;
        animation.onfinish=()=>{item.open=open;item.style.overflow='';item.animation=null;item.targetOpen=null;};
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null;this.items?.forEach(item=>{item.animation?.cancel();item.style.overflow='';item.open=item.targetOpen ?? item.open;item.targetOpen=null;}); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-friday-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bf-review-carousel')) customElements.define('bf-review-carousel',class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller=new AbortController();
      const signal=this.controller.signal;
      this.track=this.querySelector('.bf-reviews__track');
      const originals=[...this.track.children];
      this.pauses=new Set();
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.clones=[];
      if(originals.length>1){
        for(let repeat=0;repeat<Math.max(1,Math.ceil(8/originals.length));repeat++) originals.forEach(card=>{
          const clone=card.cloneNode(true);clone.setAttribute('aria-hidden','true');clone.inert=true;
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
          this.track.append(clone);this.clones.push(clone);
        });
      }
      const update=()=>{this.cycle=this.clones.length?this.clones[0].offsetLeft-originals[0].offsetLeft:0;this.position=this.track.scrollLeft;this.track.classList.toggle('is-auto',!!this.cycle&&!this.motion.matches);};
      this.addEventListener('mouseenter',()=>this.pauses.add('hover'),{signal});
      this.addEventListener('mouseleave',()=>this.pauses.delete('hover'),{signal});
      this.addEventListener('focusin',()=>this.pauses.add('focus'),{signal});
      this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget))this.pauses.delete('focus');},{signal});
      this.addEventListener('pointerdown',()=>this.pauses.add('touch'),{signal});
      const release=()=>{this.pauses.delete('touch');this.position=this.track.scrollLeft;};
      window.addEventListener('pointerup',release,{signal});window.addEventListener('pointercancel',release,{signal});
      this.motion.addEventListener('change',update,{signal});
      const move=direction=>{const card=this.track.querySelector('.bf-reviews__card');if(!card)return;this.track.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
      this.track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}},{signal});
      this.track.addEventListener('scroll',()=>{if(this.pauses.size||this.motion.matches)this.position=this.track.scrollLeft;},{signal,passive:true});
      this.addEventListener('shopify:block:select',e=>{this.pauses.add('editor');const card=e.target.closest('.bf-reviews__card');if(card){this.track.scrollTo({left:card.offsetLeft-parseFloat(getComputedStyle(this.track).paddingLeft),behavior:'instant'});}},{signal});
      this.addEventListener('shopify:block:deselect',()=>this.pauses.delete('editor'),{signal});
      this.resize=new ResizeObserver(update);this.resize.observe(this.track);update();
      let last;
      const tick=now=>{
        const elapsed=last===undefined?0:Math.min(now-last,50);last=now;
        if(this.cycle&&!this.pauses.size&&!this.motion.matches&&!document.hidden){
          this.position=(this.position+elapsed*.035)%this.cycle;
          this.track.scrollLeft=this.position;
        }
        this.frame=requestAnimationFrame(tick);
      };
      this.frame=requestAnimationFrame(tick);
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;this.resize?.disconnect();cancelAnimationFrame(this.frame);this.clones?.forEach(el=>el.remove());this.track?.classList.remove('is-auto');}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ceramic-founder-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ceramic-cta-signup')) {
    customElements.define('ceramic-cta-signup', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.querySelector('button').addEventListener('click', () => {
          const formId = this.dataset.formId.trim();
          if (!formId) return;
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', formId]);
        }, { signal:this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ceramic-founder-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ceramic-founder-count')) {
    customElements.define('ceramic-founder-count', class extends HTMLElement {
      connectedCallback() {
        if (this.observer || this.played) return;
        this.finalText = this.dataset.count || this.textContent;
        const match = this.finalText.match(/^(\s*)(\d[\d,]*)(\s*\+?\s*)$/);
        this.target = match ? Number(match[2].replace(/,/g, '')) : NaN;
        if (!Number.isSafeInteger(this.target) || this.target <= 0 || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.countPrefix = match[1];
        this.suffix = match[3];
        this.grouped = match[2].includes(',');
        this.textContent = this.countPrefix + '0' + this.suffix;
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.played = true;
          let start;
          const tick = now => {
            if (start === undefined) start = now;
            const progress = Math.min((now - start) / 1800, 1);
            const value = Math.round(this.target * (1 - Math.pow(1 - progress, 3)));
            this.textContent = progress === 1 ? this.finalText : this.countPrefix + (this.grouped ? value.toLocaleString('en-US') : String(value)) + this.suffix;
            if (progress < 1) this.frame = requestAnimationFrame(tick);
          };
          this.frame = requestAnimationFrame(tick);
        }, { threshold:0.35 });
        this.observer.observe(this.parentElement);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        cancelAnimationFrame(this.frame);
        if (this.finalText) this.textContent = this.finalText;
      }
    });
  }
  if (!customElements.get('ceramic-founder-signup')) {
    customElements.define('ceramic-founder-signup', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.querySelector('button').addEventListener('click', () => {
          const formId = this.dataset.formId.trim();
          if (!formId) return;
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', formId]);
        }, { signal:this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ceramic-launch-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ceramic-launch-signup')) {
    customElements.define('ceramic-launch-signup', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.querySelector('button').addEventListener('click', () => {
          const formId = this.dataset.formId.trim();
          if (!formId) return;
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', formId]);
        }, { signal:this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ceramic-launch-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ceramic-hero-video')) {
    customElements.define('ceramic-hero-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.manualPause = this.motion.matches || Boolean(navigator.connection?.saveData);
        this.visible = false;
        this.ready = false;
        this.sync = () => {
          if (!this.ready || !this.visible || document.hidden || this.manualPause) {
            this.video.pause();
            return;
          }
          if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
          this.video.muted = true;
          this.video.play().catch(() => { this.classList.remove('is-playing'); });
        };
        this.video.addEventListener('playing', () => {
          this.classList.add('is-playing');
        }, options);
        this.video.addEventListener('error', () => {
          this.classList.remove('is-playing');
        }, options);
        this.motion.addEventListener('change', () => {
          this.manualPause = this.motion.matches || Boolean(navigator.connection?.saveData);
          if (this.manualPause) this.classList.remove('is-playing');
          this.sync();
        }, options);
        document.addEventListener('visibilitychange', this.sync, options);
        const ready = () => { this.ready = true; this.sync(); };
        const poster = this.querySelector('picture img');
        if (!poster || poster.complete) ready();
        else {
          poster.addEventListener('load', ready, options);
          poster.addEventListener('error', ready, options);
        }
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.sync();
        }, { threshold: 0 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["visa-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('visa-faq')) {
    customElements.define('visa-faq', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        const items = [...this.querySelectorAll('details')];
        this.items=items;
        items.forEach(item => item.querySelector('summary').addEventListener('click', event => {
          event.preventDefault();
          const opening=!(item.targetOpen ?? item.open);
          if(opening)items.forEach(other=>{if(other!==item&&(other.targetOpen ?? other.open))this.transition(other,false);});
          this.transition(item,opening);
        }, options));
        document.addEventListener('shopify:block:select', event => {
          const selected = items.find(item => item.dataset.blockId === event.detail.blockId);
          if (selected) { items.forEach(other=>{if(other!==selected)this.transition(other,false);});this.transition(selected,true); }
        }, options);
      }
      transition(item,open) {
        const start=item.getBoundingClientRect().height;
        item.animation?.cancel();
        item.targetOpen=open;
        item.open=open;
        const end=item.getBoundingClientRect().height;
        if(matchMedia('(prefers-reduced-motion: reduce)').matches){item.targetOpen=null;return;}
        item.open=true;
        item.style.overflow='hidden';
        const animation=item.animate([{height:start+'px'},{height:end+'px'}],{duration:300,easing:'cubic-bezier(.22,.61,.36,1)'});
        item.animation=animation;
        animation.onfinish=()=>{item.open=open;item.style.overflow='';item.animation=null;item.targetOpen=null;};
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null;this.items?.forEach(item=>{item.animation?.cancel();item.style.overflow='';item.open=item.targetOpen ?? item.open;item.targetOpen=null;}); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["visa-product-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('visa-purchase')) {
  customElements.define('visa-purchase',class extends HTMLElement {
    connectedCallback() {
      if(this.controller)return;
      this.controller=new AbortController();const opts={signal:this.controller.signal};
      this.copy=JSON.parse(this.querySelector('[data-copy]').textContent);
      this.data=JSON.parse(this.querySelector('[data-product]').textContent);
      this.ci=Number(this.dataset.colorIndex);this.si=Number(this.dataset.sizeIndex);
      const initial=this.data.variants.find(v=>v.id===this.data.initial)||this.data.variants[0];
      this.options=initial?[...initial.options]:[];
      const sizeValues=[...new Set(this.data.variants.map(v=>v.options[this.si]).filter(Boolean))];
      this.unknown=sizeValues.find(v=>v===this.dataset.unknown)||sizeValues.find(v=>/不确定|不知道|待确认|unknown|not sure|don['’]?t know/i.test(v))||this.dataset.unknown;
      this.mode='unknown';this.size='';
      this.querySelectorAll('[data-color]').forEach(b=>b.addEventListener('click',()=>{this.options[this.ci]=b.dataset.color;this.refresh();},opts));
      this.querySelectorAll('[data-size]').forEach(b=>b.addEventListener('click',()=>{this.size=b.dataset.size;this.refresh();},opts));
      this.querySelectorAll('[data-mode]').forEach(b=>b.addEventListener('click',()=>{this.mode=b.dataset.mode;this.refresh();},opts));
      this.querySelectorAll('[data-thumb]').forEach(b=>b.addEventListener('click',()=>{
        this.selectSlide(b.closest('[data-gallery]'),b);
      },opts));
      this.querySelector('[data-add]').addEventListener('click',()=>this.add(),opts);
      this.querySelectorAll('[data-gallery]').forEach(gallery=>{
        let start=null;
        gallery.addEventListener('pointerdown',event=>{
          if(!event.isPrimary||event.button!==0||event.target.closest('button'))return;
          start={x:event.clientX,y:event.clientY,id:event.pointerId};
          gallery.setPointerCapture(event.pointerId);
        },opts);
        gallery.addEventListener('pointerup',event=>{
          if(!start||start.id!==event.pointerId)return;
          const dx=event.clientX-start.x,dy=event.clientY-start.y;start=null;
          if(Math.abs(dx)<40||Math.abs(dx)<Math.abs(dy)*1.3)return;
          const thumbs=[...gallery.querySelectorAll('[data-thumb]')];
          const index=thumbs.findIndex(b=>b.getAttribute('aria-pressed')==='true');
          const next=thumbs[(index+(dx<0?1:-1)+thumbs.length)%thumbs.length];
          if(next)this.selectSlide(gallery,next,dx<0?1:-1);
        },opts);
        gallery.addEventListener('pointercancel',()=>{start=null;},opts);
        gallery.addEventListener('dragstart',event=>event.preventDefault(),opts);
      });
      const linked=this.data.variants.find(v=>String(v.id)===new URL(location.href).searchParams.get('variant'));
      if(linked){this.options=[...linked.options];this.mode=linked.options[this.si]===this.unknown?'unknown':'known';this.size=linked.options[this.si];}
      this.refresh();
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;this.querySelectorAll('[data-slide]').forEach(s=>s.getAnimations().forEach(a=>a.cancel()));}
    selectSlide(gallery,button,direction){
      const selected=gallery.querySelector('[data-thumb][aria-pressed="true"]');
      if(selected===button)return;
      const slides=[...gallery.querySelectorAll('[data-slide]')];
      const previous=slides.find(s=>s.dataset.slide===selected?.dataset.thumb);
      const next=slides.find(s=>s.dataset.slide===button.dataset.thumb);
      if(!next)return;
      slides.forEach(s=>{s.getAnimations().forEach(a=>a.cancel());s.hidden=s!==next;});
      gallery.querySelectorAll('[data-thumb]').forEach(t=>t.setAttribute('aria-pressed',String(t===button)));
      if(!previous||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      direction=direction|| (Number(button.dataset.thumb)>Number(selected.dataset.thumb)?1:-1);
      previous.hidden=false;
      const timing={duration:380,easing:'cubic-bezier(.22,.61,.36,1)'};
      const outgoing=previous.animate([{transform:'translateX(0)'},{transform:`translateX(${-direction*100}%)`}],timing);
      next.animate([{transform:`translateX(${direction*100}%)`},{transform:'translateX(0)'}],timing);
      outgoing.onfinish=()=>{previous.hidden=true;};
    }
    resolve(size){return this.data.variants.find(v=>v.options.every((o,i)=>o===(i===this.si?size:this.options[i])));}
    refresh(){
      this.options[this.si]=this.mode==='unknown'?this.unknown:this.size;
      this.variant=this.resolve(this.options[this.si]);
      this.querySelectorAll('[data-color]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.color===this.options[this.ci])));
      this.querySelector('[data-color-label]')?.replaceChildren(document.createTextNode(this.options[this.ci]===this.dataset.white?this.copy.message_0:this.options[this.ci]===this.dataset.black?this.copy.message_1:this.options[this.ci]||''));
      this.querySelector('[data-size-label]')?.replaceChildren(document.createTextNode(this.mode==='unknown'?this.copy.message_2:this.size));
      this.querySelectorAll('[data-gallery]').forEach(g=>g.hidden=g.dataset.gallery!==(this.options[this.ci]===this.dataset.black?'black':'white'));
      this.querySelectorAll('[data-mode]').forEach(b=>b.setAttribute('aria-expanded',String(b.dataset.mode===this.mode)));
      this.querySelectorAll('[data-mode-panel]').forEach(p=>p.hidden=p.dataset.modePanel!==this.mode);
      this.querySelectorAll('[data-choice]').forEach(p=>p.classList.toggle('is-active',p.dataset.choice===this.mode));
      this.querySelectorAll('[data-size]').forEach(b=>{b.disabled=!this.resolve(b.dataset.size)?.available;b.setAttribute('aria-pressed',String(b.dataset.size===this.size));});
      const kitOK=this.mode!=='unknown'||(this.data.kit?.available&&this.data.kit.price===0&&this.data.kit.id!==this.variant?.id);
      const button=this.querySelector('[data-add]');button.disabled=!!this.busy||!this.variant?.available||!kitOK;
      button.setAttribute('aria-busy',String(!!this.busy));
      button.textContent=this.busy?this.copy.message_3:this.copy.message_4;
    }
    async add(){
      const button=this.querySelector('[data-add]');if(button.disabled||this.busy)return;
      this.busy=true;button.disabled=true;button.setAttribute('aria-busy','true');button.textContent=this.copy.message_3;const error=this.querySelector('[data-error]');error.textContent='';
      const items=[{id:this.variant.id,quantity:1}];
      if(this.mode==='unknown')items.push({id:this.data.kit.id,quantity:1,parent_id:this.variant.id,properties:{_visa_sizing_kit:'true'}});
      let added=false;
      try {
        const drawer=document.getElementById('CartDrawer');
        if(!drawer||typeof drawer.show!=='function')throw new Error(this.copy.message_5);
        const sectionId=drawer.getAttribute('data-section-id');
        const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,sections:[sectionId],sections_url:location.pathname})});
        const result=await response.json();if(!response.ok||result.status)throw new Error(result.description||result.message||this.copy.message_6);
        added=true;
        let html=result.sections?.[sectionId];
        if(!html){const refresh=await fetch(this.dataset.root+'?section_id='+encodeURIComponent(sectionId));if(!refresh.ok)throw new Error();html=await refresh.text();}
        const id='MiniCart-'+sectionId;
        const updated=new DOMParser().parseFromString(html,'text/html').getElementById(id);
        const current=document.getElementById(id);
        if(!updated||!current)throw new Error();
        current.innerHTML=updated.innerHTML;
        drawer.show(button);
      }catch(e){error.textContent=added?this.copy.message_7:e.message;}
      finally{this.busy=false;this.refresh();}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["visa-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('visa-testimonials')) {
    customElements.define('visa-testimonials', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.buttons = [...this.querySelectorAll('[data-index]')];
        this.photos = [...this.querySelectorAll('[data-photo]')];
        this.backgrounds = [...this.querySelectorAll('[data-background]')];
        this.names = [...this.querySelectorAll('[data-name]')];
        this.reviews = [...this.querySelectorAll('[data-review]')];
        this.active = 0;
        this.animations = [];
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.buttons.forEach((button,index) => {
          button.addEventListener('pointerenter',event => { if(event.pointerType === 'mouse') this.select(index); },options);
          button.addEventListener('focus',() => this.select(index),options);
          button.addEventListener('click',() => this.select(index),options);
          button.addEventListener('keydown',event => {
            let next = index;
            if(event.key === 'ArrowRight') next = Math.min(index+1,this.buttons.length-1);
            else if(event.key === 'ArrowLeft') next = Math.max(index-1,0);
            else if(event.key === 'Home') next = 0;
            else if(event.key === 'End') next = this.buttons.length-1;
            else return;
            event.preventDefault(); this.buttons[next].focus();
          },options);
        });
        this.prev.addEventListener('click',() => this.select(this.active-1),options);
        this.next.addEventListener('click',() => this.select(this.active+1),options);
        document.addEventListener('shopify:block:select',event => {
          const index=this.buttons.findIndex(button=>button.dataset.blockId===event.detail.blockId);
          if(index>=0) this.select(index);
        },options);
      }
      disconnectedCallback() {
        this.controller?.abort(); this.controller=null;
        this.animations?.forEach(animation=>animation.cancel());
      }
      select(index) {
        if(index===this.active || index<0 || index>=this.buttons.length) return;
        const previous=this.active;
        this.animations.forEach(animation=>animation.cancel());
        this.animations=[];
        this.active=index;
        this.photos.forEach((photo,i)=>{photo.hidden=i!==index && i!==previous;photo.style.zIndex=i===index?'2':'1';});
        this.buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
        this.backgrounds.forEach((background,i)=>background.style.opacity=i===index?'1':'0');
        this.names.forEach((name,i)=>name.hidden=i!==index);
        this.reviews.forEach((review,i)=>review.hidden=i!==index);
        this.prev.disabled=index===0;
        this.next.disabled=index===this.buttons.length-1;
        if(matchMedia('(prefers-reduced-motion: reduce)').matches || !this.photos[index].animate) {
          this.photos.forEach((photo,i)=>photo.hidden=i!==index); return;
        }
        const motion=this.photos[index].animate([{transform:'translateX(100%)'},{transform:'translateX(0)'}],{duration:760,easing:'cubic-bezier(.22,1,.36,1)'});
        this.animations.push(motion);
        motion.finished.then(()=>{if(this.active===index)this.photos.forEach((photo,i)=>photo.hidden=i!==index);}).catch(()=>{});
        [this.names[index],this.reviews[index]].forEach(element=>{
          this.animations.push(element.animate([{opacity:0,transform:'translateX(18px)'},{opacity:1,transform:'translateX(0)'}],{duration:600,easing:'cubic-bezier(.22,1,.36,1)'}));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
